export default __webpack_public_path__ + "static/media/payment-bg.8027036c.png";